<template>
  <el-dialog
    :title="title"
    :destroy-on-close="true"
    @open="loadExportTableData()"
    @closed="closeDialog()"
    :visible.sync="dialogVisible"
    width="840px"
    center
  >
    <el-table :data="exportTableData" v-loading="dataExportLoading">
      <!-- <el-table-column property="traceId" label="序列号" center></el-table-column> -->
      <el-table-column property="gmtCreate" label="申请时间" width="140px" align="center"></el-table-column>
      <el-table-column label="查询条件" width="360px" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p style="max-width:360px">{{ scope.row.exportCondition }}</p>
            <div slot="reference">
              <label size="medium">{{
                scope.row.exportCondition === '' ? '' : scope.row.exportCondition.substring(0, 100) + '...'
              }}</label>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column property="url" label="文件地址" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0" style="color: orange">处理中</span>
          <span v-if="scope.row.status === 1"><a style="color: dodgerblue" :href="scope.row.url">下载</a></span>
          <span v-if="scope.row.status === 2" style="color: red">处理失败:{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column property="expirationTime" label="失效时间" center></el-table-column> -->
      <el-table-column property="gmtCreator" label="操作人" align="center"></el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import * as dataExport from '@/api/dataExport'

export default {
  name: 'DataExport',
  props: {
    exportType: {
      type: String,
      default: () => '',
    },
    condition: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      title: '数据导出',
      dialogVisible: false,
      exportInterval: null,
      exportTableData: [],
      dataExportLoading: false,
    }
  },
  methods: {
    // 发送导出请求成功，并显示弹出框
    async exportVisible(path, title) {
      // 进行本地导出调用
      const response = await dataExport.exportData(path, this.condition)
      if (response.status === 200 && response.data.status === 0) {
        this.startShowExportTask()
        this.dialogVisible = true
        this.title = title
      } else {
        this.$message.error(response.data.message)
      }
    },

    async loadExportTableData() {
      this.dataExportLoading = true
      const response = await dataExport.list(this.exportType)
      this.exportTableData = response.data.data
      this.dataExportLoading = false
    },

    startShowExportTask() {
      let that = this
      this.exportInterval = setInterval(async () => {
        const response = await dataExport.list(that.exportType)
        this.exportTableData = response.data.data
        let timerSwitch = true
        if (response.data.data && response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            let item = response.data.data[i]
            if (item.status === 0) {
              timerSwitch = false
              break
            }
          }
        }
        if (timerSwitch) {
          clearInterval(that.exportInterval)
          that.exportInterval = null
        }
      }, 3000)
    },

    closeDialog() {
      let that = this
      this.dialogVisible = false
      this.$nextTick(() => {
        if (that.exportInterval) {
          clearInterval(this.exportInterval)
          this.exportInterval = null
        }
      })
    },
  },
}
</script>
